'use client'
import { Modal } from 'antd'
import React from 'react'
import { useSharedData } from 'bossjob-remote/dist/hooks'
import styles from './index.module.scss'
import JobPrefHomeModal from './DesiredForm/jobPref.home.pc'

export default function JobPrefForHomeModal({
  lang,
  open,
  onClose,
  onFinish,
  job_preferences = [],
  jobDetail = {},
  type = 'edit'
}) {
  const config = useSharedData('CONFIG') ?? {}

  const getPreferences = async (id, data) => {
    try {
      if (id) {
        setTimeout(() => {
          onFinish?.(id, data)
        }, 200)
      }
    } catch (error) {}
  }

  return (
    <Modal
      wrapClassName='myJobModal'
      open={open}
      onCancel={onClose}
      width={500}
      zIndex={1040}
      title={null}
      footer={null}
      styles={{
        content: {
          borderRadius: '12px'
        }
      }}
    >
      <div className={styles.preferenceModal}>
        {config && (
          <JobPrefHomeModal
            lang={lang}
            config={config}
            onCancel={onClose}
            jobDetail={jobDetail}
            preferences={job_preferences}
            getPreferences={getPreferences}
            type={type}
          />
        )}
      </div>
    </Modal>
  )
}
